import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Account } from '../models/account';
import { environment } from '../../environments/environment';
import { HttpResponseInterface } from '../interfaces/iHttpResponse';
import { Router } from '@angular/router';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {
  public loggedIn = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient, private router:Router, private accountService:AccountService) {
    if (this.getToken()) {
      this.loggedIn.next(true);
    }
  }

  public login(email: string, password: string): Observable<any> {
    return this.http.post<HttpResponseInterface>(`${environment.apiEndpoint}/api/login`, {email: email, password: password}).pipe(
      map(res => {
        return res;
      })
    );
  }

  public register(registration): Observable<any> {
    registration.type = 'consumer';
    const newAccount = new Account(registration);
    return this.http.post<HttpResponseInterface>(`${environment.apiEndpoint}/api/register`, newAccount).pipe(
      map((res) => {
        this.storeLogin(res);
        this.router.navigate(['/']);
      })
    );
  }

  public logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('account');
        this.loggedIn.next(false);
        this.router.navigate(['/']);
  }

  public clear(){
    localStorage.removeItem('token');
    localStorage.removeItem('account');
    this.loggedIn.next(false);
  }

  storeLogin(data) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('account',JSON.stringify(data.user));
    this.loggedIn.next(true);
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  public getAccount() {
    return new Account(JSON.parse(localStorage.getItem('account')));
  }


}